import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

// White-label accent presets (CSS values applied via --rl-accent / --rl-accent-strong).
export const ACCENTS = {
  orange: { label: "Innovationshafen", value: "#F8991D", strong: "#DD7F0A" },
  iosblue: { label: "iOS Blau (Apple)", value: "#007AFF", strong: "#0062CC" },
  iosgreen: { label: "iOS Grün (Apple)", value: "#34C759", strong: "#248A3D" },
  iosindigo: { label: "iOS Indigo (Apple)", value: "#5856D6", strong: "#3634A3" },
  blue: { label: "Blau", value: "#2563EB", strong: "#1D4ED8" },
  teal: { label: "Türkis", value: "#0D9488", strong: "#0F766E" },
  violet: { label: "Violett", value: "#7C3AED", strong: "#6D28D9" },
  rose: { label: "Rosé", value: "#E11D48", strong: "#BE123C" },
  amber: { label: "Bernstein", value: "#D97706", strong: "#B45309" },
  emerald: { label: "Smaragd", value: "#059669", strong: "#047857" },
};

function applyTheme(mode) {
  const root = document.documentElement;
  if (mode === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

function applyAccent(key) {
  const a = ACCENTS[key] || ACCENTS.blue;
  const root = document.documentElement;
  root.style.setProperty("--rl-accent", a.value);
  root.style.setProperty("--rl-accent-strong", a.strong);
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("rl_theme") || "light");
  const [accent, setAccentState] = useState(() => {
    // Einmalige Migration: altes Standard-Blau -> Innovationshafen-Orange
    if (!localStorage.getItem("rl_accent_v2")) {
      localStorage.setItem("rl_accent_v2", "1");
      if ((localStorage.getItem("rl_accent_key") || "blue") === "blue") {
        localStorage.setItem("rl_accent_key", "orange");
      }
    }
    return localStorage.getItem("rl_accent_key") || "orange";
  });

  useEffect(() => { applyTheme(mode); localStorage.setItem("rl_theme", mode); }, [mode]);
  useEffect(() => { applyAccent(accent); localStorage.setItem("rl_accent_key", accent); }, [accent]);

  const toggleMode = () => setMode((m) => (m === "dark" ? "light" : "dark"));
  const setAccent = (key) => setAccentState(key);

  return (
    <ThemeContext.Provider value={{ mode, toggleMode, setMode, accent, setAccent }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
